






const actions = {
  setDevice({ commit }, devId) {
    commit('SET_DEVICE', devId)
  },

  setDevList({ commit }, list) {
    commit('SET_LIST', list)
  },
  setDevType({ commit }, devId) {
    commit('SET_DEVTYPE', devId)
  },
}





const state = {

  devId: "",
  devList:[],
  devType:""

}

const mutations = {

  SET_DEVICE: (state, list) => {
    state.devId=list;
  },
  SET_LIST: (state, list) => {
    state.devList=list;
  },
  SET_DEVTYPE: (state, list) => {
    state.devType=list;
  },
}



export default {
  namespaced: true,
  state,
  mutations,
  actions
}
